{
  "days": {
    "Monday": "திங்கள்",
    "Tuesday": "செவ்வாய்",
    "Wednesday": "புதன்",
    "Thursday": "வியாழன்",
    "Friday": "வெள்ளி",
    "Saturday": "சனி",
    "Sunday": "ஞாயிறு"
  },
  "months": {
    "January": "ஜனவரி",
    "February": "பிப்ரவரி",
    "March": "மார்ச்",
    "April": "ஏப்ரல்",
    "May": "மே",
    "June": "ஜூன்",
    "July": "ஜூலை",
    "August": "ஆகஸ்ட்",
    "September": "செப்டம்பர்",
    "October": "அக்டோபர்",
    "November": "நவம்பர்",
    "December": "டிசம்பர்"
  },
  "actions": {
    "StartReading": "வாசிக்கத் தொடங்கவும்",
    "PreviewEdition": "முன்னோட்டப் பதிப்பு",
    "Download": "பதிவிறக்க",
    "Retry": "மீண்டும் முயல்க",
    "ReadePaper": "மின்னிதழைப் படிக்க",
    "TryAgain": "மீண்டும் முயலவும்"
  },
  "preview": {
    "bottomBar": {
      "subscribe": "சந்தா விவரம் அறிக",
      "login": "ஏற்கனவே சந்தாதாரரா? உள்நுழையவும்"
    },
    "gate": {
      "title": "காப்பகத்தைக் காண சந்தா சேருங்கள்",
      "body": "சந்தாதாரர்களுக்கு முழு பதிப்பு, ஆஃப்லைன் வாசிப்பு மற்றும் பகிர்வுடன் காப்பகமும் கிடைக்கும்.",
      "cta": "சந்தா விவரம் அறிக"
    }
  },
  "multiTitle": {
    "st": "",
    "zb": "联合早报",
    "bh": "",
    "tm": "தமிழ் முரசு",
    "sm": "新明日报",
    "bt": "",
    "bm": "",
    "mm": "",
    "tabla": "Tabla!"
  },
  "tooltip": {
    "Logout": "வெளியேறுதல்",
    "Onboarding": "குறிப்புகள்",
    "CalenderView": "காலண்டர்",
    "TileView": "சிறுபடம்",
    "StartReading": "படிக்க கிளிக் செய்யவும்a"
  }
}
